<style scoped lang="scss">
.development-content-div {
    height: fit-content;
    width: 100vw;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    font-size: 1rem;
    min-height: 100vh;
    padding: 1.5rem;
}

.not-developer-praent {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.not-developer-div {
    padding: 2rem;
    width: fit-content;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    }
    
    p {
        font-size: 1.1rem;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
    }
    
    .el-button {
        padding: 0.75rem 1.5rem;
        font-size: 1rem;
        border-radius: 8px;
        transition: all 0.2s ease;
        
        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
    }
}

.deveploer-content {
    padding: 2rem;
    margin: 2rem;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    }
    
    .plugin-count {
        font-size: 1.2rem;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
        position: relative;
        padding-left: 1.25rem;
        
        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 1.2rem;
            background: linear-gradient(to bottom, #6B46C1, #805AD5);
            border-radius: 2px;
        }
    }
    
    .plugin-selector {
        display: flex;
        align-items: center;
        margin-bottom: 2rem;
        
        .el-select {
            margin-left: 1rem;
            width: 240px;
            
            :deep(.el-input__inner) {
                border-radius: 8px;
                border-color: rgba(107, 70, 193, 0.2);
                transition: all 0.2s ease;
                
                &:hover, &:focus {
                    border-color: #6B46C1;
                    box-shadow: 0 0 0 2px rgba(107, 70, 193, 0.1);
                }
            }
        }
    }
}

.data-table {
    width: 100%;
    margin: 2rem 0;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    
    caption {
        padding: 1rem;
        color: #64748b;
        font-size: 0.9rem;
        text-align: left;
    }
    
    th, td {
        padding: 1rem;
        text-align: center;
        border: 1px solid rgba(107, 70, 193, 0.1);
        transition: all 0.2s ease;
    }
    
    th {
        background: #f8fafc;
        font-weight: 600;
        color: #1a1a1a;
        
        &:first-child {
            background: #6B46C1;
            color: white;
        }
    }
    
    tr {
        transition: all 0.2s ease;
        
        &:hover {
            background: rgba(107, 70, 193, 0.02);
            
            td {
                color: #6B46C1;
            }
        }
        
        &:nth-child(even) {
            background: rgba(107, 70, 193, 0.01);
        }
    }
}

.canvas-div {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin-top: 2rem;
    
    canvas {
        width: 80% !important;
        background: white;
        border-radius: 12px;
        padding: 1rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        }
    }
}

@media screen and (max-width: 768px) {
    .development-content-div {
        padding: 0.8rem;
        padding-bottom: 3rem;
    }
    
    .deveploer-content {
        padding: 0.5rem;
        margin: 0;
    }
    
    .data-table {
        margin: 1rem 0;
        
        th, td {
            padding: 0.75rem;
            font-size: 0.9rem;
        }
    }
    
    .canvas-div {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
    
    canvas {
        width: 100% !important;
        background: white;
        border-radius: 12px;
        padding: 1rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        }
    }
}
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main style="padding-top: 0;padding-left: 0;background-color: rgb(242, 242, 242) !important;overflow: auto;height:100vh;">
                    <div class="development-content-div">
                        <div v-if="isDeveloper == 0" class="not-developer-praent">
                            <div class="not-developer-div">
                                <p style="font-size: 1rem;">您还不是开发者，暂时无法查看本页面喔~</p>
                                <div
                                    style="text-align: center; width: fit-content;margin: 3rem auto 0.5rem;font-size: 1rem;">
                                    <el-button type="primary" @click="goApiUrl">
                                        成为开发者
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <div v-if="isDeveloper == 1" class="d-flex flex-column deveploer-content rounded shadow">
                            <div style="margin-left: 1rem;font-weight: bold;">您累计开发插件个数：{{ deveploerData.num }}
                            </div>
                            <div class="d-flex flex-row align-items-center mt-2" style="margin-left: 1rem;">
                                <div>查看指定插件数据</div>
                                <el-select v-model="select_includes" clearable placeholder="Select"
                                    style="width: 240px;margin-left: 1rem;width: 8rem;"
                                    @change="getIncludesData(select_includes)">
                                    <el-option label="全部插件" value="-1" />
                                    <el-option v-for="item in deveploerData.list" :key="item.id" :label="item.name"
                                        :value="item.id" />
                                </el-select>
                            </div>
                            <table class="table table-bordered data-table">
                                <caption>注意：续费次数也包含在授权次数内</caption>
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">今日</th>
                                        <th scope="col">昨日</th>
                                        <th scope="col">共计</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">收益(元)</th>
                                        <td>{{ deveploerData.todayData.authorIncome }}（元）</td>
                                        <td>{{ deveploerData.yesterdayData.authorIncome }}（元）</td>
                                        <td>{{ deveploerData.totalData.authorIncome }}（元）</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">新增授权</th>
                                        <td>{{ deveploerData.todayData.newAuth }}（个）</td>
                                        <td>{{ deveploerData.yesterdayData.newAuth }}（个）</td>
                                        <td>{{ deveploerData.totalData.newAuth }}（个）</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">新增代理</th>
                                        <td>{{ deveploerData.todayData.newAgent }}（个）</td>
                                        <td>{{ deveploerData.yesterdayData.newAgent }}（个）</td>
                                        <td>{{ deveploerData.totalData.newAgent }}（个）</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="canvas-div">
                                <canvas id="newIncomeCanvas"></canvas>
                                <canvas id="newAuthCanvas"></canvas>
                                <canvas id="newAgentCanvas"></canvas>
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { Chart, registerables } from 'chart.js';
import 'chart.js/auto';
import 'chartjs-adapter-date-fns';
import { isLogin, isNull, compareDates, openBox } from "@/utils/publicMethods"
import { ElMessage, ElNotification, ElMessageBox } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            isDeveloper: 2,
            deveploerConf: {
                apiUrl: ""
            },
            deveploerData: {},
            select_includes: "全部插件",
            everyDayData: {},
            newIncomeChart: "",
            newAuthChart: "",
            newAgentChart: "",
        }
    },
    methods: {
        goApiUrl() {
            location.href = this.deveploerConf.apiUrl;
        },
        getInfo() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getInfo', { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.deveploerData = res.data.data
                        this.everyDayData = res.data.data.everyDayData;
                        this.drawEveryDayData();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(res.data.data)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getIncludesData(id) {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getIncludesData?id=' + id, { timeout: 30000, headers })
                .then(res => {
                    console.log(res.data);
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.deveploerData.todayData = res.data.data.todayData;
                        this.deveploerData.yesterdayData = res.data.data.yesterdayData;
                        this.deveploerData.totalData = res.data.data.totalData;
                        this.everyDayData = res.data.data.everyDayData;
                        this.drawEveryDayData();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        this.openBox()
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        drawEveryDayData() {
            let labels = [];
            let incomeDatas = [];
            let authDatas = [];
            let agentDatas = [];
            this.everyDayData.sort(compareDates);
            for (let i = 0; i < this.everyDayData.length; i++) {
                const element = this.everyDayData[i];
                const value = element.log;
                labels.push(element.date);
                incomeDatas.push(value.authorIncome);
                authDatas.push(value.newAuth);
                agentDatas.push(value.newAgent);
            }
            setTimeout(() => {
                this.drawGraphics(labels, incomeDatas, "十日收入图", 'newIncomeCanvas');
                this.drawGraphics(labels, authDatas, "十日新增授权数", 'newAuthCanvas');
                this.drawGraphics(labels, agentDatas, "十日新增代理数", 'newAgentCanvas');
            }, 200);
        },
        drawGraphics(labels, data1, title, idName) {
            if (this.isNull(idName) || labels == null || data1 == null || labels.length == 0 || data1.length == 0 || labels.length != data1.length) {
                return
            } var myChart = "";
            var yTitle = "";
            var xTitle = "日期";
            if (idName == 'newIncomeCanvas') {
                myChart = this.newIncomeChart
                yTitle = "收益(元)"
            }
            else if (idName == 'newAgentCanvas') {
                myChart = this.newAgentChart
                yTitle = "新增代理(个)"
            } else {
                myChart = this.newAuthChart
                yTitle = "新增授权(个)"
            }
            const ctx = document.getElementById(idName).getContext('2d');
            if (myChart) {
                myChart.destroy();
            }
            const data = {
                labels: labels,
                datasets: [{
                    label: title,
                    data: data1,
                    fill: false,
                    borderColor: 'rgb(75, 192, 192)', // 设置线的颜色
                    tension: 0.1
                }]
            };
            const config = {
                type: 'line', // 设置图表类型
                data: data,
                options: {
                    responsive: true,
                    scales: {
                        y: {
                            min: 0,
                            ticks: {
                                font: {
                                    size: 15
                                }
                            },
                            title: {
                                display: true,
                                text: yTitle,
                                font: {
                                    size: 15,
                                },
                            },
                        },
                        x: {
                            ticks: {
                                font: {
                                    size: 15
                                }
                            }, title: {
                                display: true,
                                font: {
                                    size: 15,
                                },
                            },
                        },
                    }
                },
                plugins: {
                    legend: {
                        display: true,
                        labels: {
                        },
                    },
                    title: {
                        display: true,
                        text: title,
                    },
                },
            };
            myChart = new Chart(ctx, config);
            if (idName == 'newIncomeCanvas') {
                this.newIncomeChart = myChart;
            } else if (idName == 'newAgentCanvas') {
                this.newAgentChart = myChart;
            } else {
                this.newAuthChart = myChart;
            }

        },
        isNull(text) {
            return isNull(text);
        }
    },
    mounted() {
        this.getInfo()
        window.ResizeObserver = this.$nativeResizeObserver
    }
})
</script>
